import React, { useCallback, useEffect, useState } from "react"
import Particles, { initParticlesEngine } from "@tsparticles/react"
import { loadFull } from "tsparticles"
import { particleWrapper } from "./particle-container.module.css"

const ParticleContainer = ({ isActive, setIsActive }) => {
  const [init, setInit] = useState(false)

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadFull(engine)
    }).then(() => {
      setInit(true)
    })
  }, [])

  const baseEmitterConfig = (direction, position) => {
    return {
      direction,
      rate: {
        quantity: 15,
        delay: 0.3,
      },
      size: {
        width: 0,
        height: 0,
      },
      particles: {
        color: {
          value: ["#ee8000", "#0046EB", "#FF5C00"],
        },
      },
      position,
    }
  }

  const emitterList = [
    baseEmitterConfig("top-right", { x: 0, y: 30 }),
    baseEmitterConfig("top-left", { x: 100, y: 30 }),
  ]

  const configs = {
    background: {
      opacity: 1,
    },
    particles: {
      angle: {
        value: 0,
        offset: 30,
      },
      move: {
        enable: true,
        outModes: {
          top: "none",
          default: "destroy",
        },
        gravity: {
          enable: true,
        },
        speed: { min: 5, max: 20 },
        decay: 0.01,
      },
      number: {
        value: 0,
        limit: 200,
      },
      opacity: {
        value: 1,
      },
      shape: {
        type: ["circle", "square", "triangle"],
      },
      size: {
        value: { min: 4, max: 7 },
        animation: {
          count: 1,
          startValue: "min",
          enable: true,
          speed: 5,
          sync: true,
        },
      },
      rotate: {
        value: {
          min: 0,
          max: 360,
        },
        direction: "random",
        animation: {
          enable: true,
          speed: 60,
        },
      },
      tilt: {
        direction: "random",
        enable: true,
        value: {
          min: 0,
          max: 360,
        },
        animation: {
          enable: true,
          speed: 60,
        },
      },
      roll: {
        enable: true,
        speed: {
          min: 15,
          max: 25,
        },
      },
      wobble: {
        distance: 30,
        enable: true,
        speed: {
          min: -15,
          max: 15,
        },
      },
    },
    emitters: isActive ? emitterList : [],
  }

  const options = {
    background: {
      opacity: 1,
    },
    particles: {
      zIndex: 10000,
      number: {
        value: 0,
      },
      color: {
        value: ["#ee8000", "#0046EB", "#FF5C00"],
      },
      shape: {
        type: ["circle", "square", "triangle", "polygon"],
        options: {
          polygon: [
            {
              sides: 5,
            },
            {
              sides: 6,
            },
          ],
        },
      },
      opacity: {
        value: {
          min: 0,
          max: 1,
        },
        animation: {
          enable: true,
          speed: 2,
          startValue: "max",
          destroy: "min",
        },
      },
      size: {
        value: {
          min: 2,
          max: 4,
        },
      },
      links: {
        enable: false,
      },
      life: {
        duration: {
          sync: true,
          value: 5,
        },
        count: 1,
      },
      move: {
        enable: true,
        gravity: {
          enable: true,
          acceleration: 10,
        },
        speed: {
          min: 10,
          max: 20,
        },
        decay: 0.1,
        direction: "none",
        straight: false,
        outModes: {
          default: "destroy",
          top: "none",
        },
      },
      rotate: {
        value: {
          min: 0,
          max: 360,
        },
        direction: "random",
        move: true,
        animation: {
          enable: true,
          speed: 60,
        },
      },
      tilt: {
        direction: "random",
        enable: true,
        move: true,
        value: {
          min: 0,
          max: 360,
        },
        animation: {
          enable: true,
          speed: 60,
        },
      },
      roll: {
        darken: {
          enable: true,
          value: 25,
        },
        enable: true,
        speed: {
          min: 15,
          max: 25,
        },
      },
      wobble: {
        distance: 30,
        enable: true,
        move: true,
        speed: {
          min: -15,
          max: 15,
        },
      },
    },
    emitters: isActive
      ? {
          position: {
            x: 8,
            y: 5,
          },
          life: {
            count: 1,
            duration: 0.1,
            delay: 0.4,
          },
          rate: {
            delay: 0.1,
            quantity: 150,
          },
          size: {
            width: 0,
            height: 0,
          },
        }
      : [],
  }

  const particlesLoaded = (container) => {
  }

  if (init) {
    return (
      <Particles
        className={particleWrapper}
        id="tsparticles"
        particlesLoaded={particlesLoaded}
        options={options}
      />
    )
  } else {
    return null
  }
}

export default ParticleContainer
